import * as React from "react";
import classnames from "classnames";
/* empty css                           */
const HorizontalButtonGroup = ({
  Button,
  items,
  className,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("horizontal-button-group", className) }, items.map((item) => /* @__PURE__ */ React.createElement(
  Button,
  {
    ...item,
    key: item.itemID,
    className: classnames(item?.className, "horizontal-button-group__item")
  }
)));
export {
  HorizontalButtonGroup as default
};
//# sourceMappingURL=HorizontalButtonGroup.js.map
